import IsaasImporter from "./IsaasImporter.js";
import UnicontaIsaasIntegration from "../../../../models/integration/UnicontaIsaasIntegration.js";

/**
 * `UnicontaIsaasImporter` Import wizard for the Uniconta integration using iSaaS.
 */
export default class UnicontaIsaasImporter extends IsaasImporter {
	_getConnectorType() {
		return "uniconta";
	}

	_wantExtendedActionsInConfigureImportDataStep() {
		return false;
	}
}

UnicontaIsaasImporter.integrationType = UnicontaIsaasIntegration.getType();
